import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  widthValue?: number;
  labelColor?: string;
  rowValue?: boolean;
  flex?: Boolean;
  selected?: boolean;
  transparent?: boolean;
}

export const Root = styled.div`
  z-index: 300;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.45);
  font-family: Roboto;
`

export const BoxContainer = styled.div`
  position: relative;
  width: ${(props: IRootProps) => (props.widthValue ?? 1344)}px;  
  height: calc(100vh - 120px - 10px);
  padding: 0px 0px 86px 0px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 6px;
`

export const TitleContainer = styled.div`
  height: 96px;
  padding: 0px 60px 0px 60px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
  background-color: rgba(18, 36, 66, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`

export const LeftSide = styled.div`
`

export const Title = styled.div`
  padding: 0px 0px 11px 0px;
  text-transform: capitalize;
`

export const SubtitleContainer = styled.div`
  display: flex;
`


export const Content = styled.div`
  height: calc(100% - 140px);  
`
export const Description = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  margin-bottom: 15px;
`;

export const LoadContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Container = styled.div`
  display: block;
`;

export const Images = styled.div`
  display: inline-block;
  width: 144px;
  height: 147px;
  padding: 10px 0px;
  text-align: center;
`;

export const TextInfo = styled.div`
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8891a0;
  margin-top: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 144px;
`;

export const ActionsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 60px;
  bottom: 48px;
`

export const Error = styled.div`
  font-weight: bold;
  margin-right: 6px;
`

export const Action = styled.div`
  min-width: 112px;
`

export const FieldsContainer = styled.div`
  width: ${(props: IRootProps) => (props.rowValue ?  `100%` : `auto`)};
  display: ${(props: IRootProps) => (props.rowValue ?  `flex` : `auto`)};
  justify-content: ${(props: IRootProps) => (props.rowValue ?  `space-between` : `auto`)};
  flex-wrap: ${(props: IRootProps) => (props.rowValue ?  `wrap` : `auto`)};
`

export const FilesContainer = styled.div`
  width: 250px;
  height: 400px;
  overflow: auto;
  padding: 15px 19px 15px 19px;
  border-radius: 5px;
  border: solid 1px #8d8d8d;
`

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`

export const FileTitle = styled.div`
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8891a0;
  white-space: nowrap;
`

export const FileSize = styled.div`
  padding: 0px 0px 0px 10px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8891a0;
  white-space: nowrap;
`

export const FilePreviewContainer = styled.div`
  position: fixed;
  right: ${window.innerWidth/2}px;
  display: none;
  border-radius: 5px;
  z-index: 5;
  background-color: ${C.DARKER_GRAY};
  padding: 12px;
  ${FileRow}:hover & {
    display: block;
  }
`

export const FilePreview = styled.img`
  width: 118px;
  height: 78px;
  object-fit: cover;
  border-radius: 5px;
`

export const LoaderContainer = styled.div`
`
export const EndContainer = styled.div`
`

export const DesignsContainer = styled.div`
  box-sizing: border-box;
  margin: 10px 0 0 0;
  width: 100%;
  position: relative;
  height: calc(100vh - 430px);
  overflow-y: auto;
 
`

export const EmptyContainer = styled.div`
  box-sizing: border-box;
  margin: 10px 0 0 0;
  width: 100%;
  position: relative;
  height:350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #c9c9c9;
`

export const DesignsWrap = styled.div`
  .group-list {
    padding: 8px;
    display: ${(props: IRootProps) => props.flex ? 'grid' : 'unset'};
    grid-template-columns: ${(props: IRootProps) => props.flex ? 'repeat(auto-fill, 230px)' : 'unset'};
    justify-content: ${(props: IRootProps) => props.flex ? 'space-between' : 'unset'};
  }
`

export const PreviewContainer = styled.div`
  flex: 1;
  height: 140px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
  border-radius: 5px;
  background-color: ${C.WHITE};    
  border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid white`)};
  cursor: pointer;
  transition: transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    transform: scale(1.05);
    border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid rgba(32, 64, 120, 0.3)`)};
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);    
  }
  
`;



export const ImgContainer = styled.img`
  height: 110px;
  display: flex;
  
  width: 85%;
  text-align: center;
  object-fit: contain;
  box-sizing: border-box;
  ${(props: IRootProps) => (props.transparent ? `{
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAQMAAAC3R49OAAAABlBMVEX////09PQtDxrOAAAAE0lEQVQI12P4f4CBKMxg/4EYDAAFkR1NiYvv7QAAAABJRU5ErkJggg==');
    background-image: linear-gradient(45deg, $color 25%, transparent 25%), linear-gradient(-45deg, $color 25%, transparent 25%), linear-gradient(45deg, transparent 75%, $color 75%), linear-gradient(-45deg, transparent 75%, $color 75%);
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;

    

  }` : ``)};
    
`;

export const ImgTitle = styled.div`
  display:flex;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-top:4px;
  color: #8891a0;
  `;

  export const radioContainer = styled.div`
  display:flex;
  margin-top:20px;
  
  width:100%;
`;

export const SearchText = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: rgba(141, 141, 141, 0.5);
  margin-bottom: 18px;
`;